import React, {Component} from 'react';
import styled from 'styled-components'

const LogoImage = styled.img`
`;

const LogoName = styled.span`
    font-family: 'NunitoBold', Fallback, sans-serif;
    font-size: 2.5rem;
    text-align: center;
    color: ${props => props.theme.logoPurple};
`;

const Wrapper = styled.div.attrs({
})`
`;
const LogoColumn = styled.div.attrs({
    className: "col-xs-4 col-sm-2 col-md-4 col-lg-2",
})`
    margin-top: auto;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 6.7rem;
`;
const LogoNameColumn = styled.div.attrs({
    className: "col-xs-6 col-xs-offset-2 col-sm-10 col-sm-offset-3 col-md-5 col-md-offset-3 col-lg-offset-3",
})`
    margin-top: auto;
    color: ${props => props.theme.primaryColor};
    font-family: ${props => props.theme.logoFontFamily};
`;

class Header extends Component {
    render() {
        return (
            <Wrapper>
                <LogoColumn>
                    <LogoImage src={this.props.logoImage}/>
                </LogoColumn>
                <LogoNameColumn>
                    <LogoName>envimation</LogoName>
                </LogoNameColumn>
            </Wrapper>
        );
    }
}

export default Header;
export {LogoImage, LogoColumn, LogoName, LogoNameColumn, Wrapper}
